export default __webpack_public_path__ + "static/media/eldenring.a7a8f755.png";